import { createContext, useCallback, useContext } from "react";
import { Camera, Quaternion, Vector3 } from "three";

import { TypedEventEmitter, createTypedEventEmitter } from "src/shared/util";

import type { BoardCameraAPI } from "../render/camera/BoardCamera";

export type CameraContext = {
  events: TypedEventEmitter<{
    update: void;
  }>;
  boardCamera?: BoardCameraAPI;
  camera?: Camera;
  centerPoint?: Vector3;
  worldRotation?: Quaternion;
};

export const CameraContext = createContext<CameraContext>({
  events: createTypedEventEmitter()
});

export function useCamera(): [CameraContext, () => void] {
  const ctx = useContext(CameraContext);
  const update = useCallback(() => ctx.events.emit("update"), [ctx]);
  return [ctx, update];
}
